import React, { useState, useEffect } from 'react';

import './Text.css'

const TEXT_REGEX = /\n/g

const Text = (props) => {
  // Property value
  const { value } = props
  // Property functions
  const { updateComponent, menuOnShow, menuOnHide } = props
  const [ regexResult, setRegexResult ] = useState()
  const regex_result = value.match(TEXT_REGEX)

  // useEffect(() => {
  //   const regex_result = props.value.match(TEXT_REGEX)
  //   setRegexResult(regex_result)
  // })

  // const [textValue, setTextValue] = useState(value)
  const rows_count = value.length===0 ? 1 : Math.ceil(value.length / 58);
  // const overflowRowFlag = value.length > 58 ? true : false
  // useEffect(() => {
  //   setTextValue(value)
  // }, [value])

  // const lazyUpdateTimeout = (propName, value) => {
  //   clearTimeout(lazyUpdate_timeout)
  //   setLazyUpdate_timeout(setTimeout(() => {
  //     updateComponent({
  //       [propName]: value
  //     })
  //     setLazyUpdate_timeout(null)
  //     // console.log("Module action 실행 => ", )
  //   }, 300))
  // }

  const onInput_text = (e) => {
    const { value } = e.target
    // setTextValue(value)
    updateComponent({
      value: value
    })
  }

  return (
    <textarea 
      rows={rows_count+ (regex_result ? regex_result.length : 0)}
      className="text-component"
      placeholder={"텍스트 컴포넌트 내용 입력 ..."}
      value={value} 
      onInput={onInput_text}
      onSelect={() => {menuOnShow()}}
      onBlur={() => {menuOnHide()}}
      // readOnly={true}
      // onMouseOver={onOver}
    />
  )
}

export default Text